import { receiptPrintStyles } from '@/constants'
import { Paper, Stack, Text } from '@mantine/core'

export function PrintStyles() {
  return <style>{receiptPrintStyles}</style>
}

export function PrintReceipts({ receipts_html }: { receipts_html: string[] }) {
  return (
    <div className="print-only">
      {receipts_html.map((html, index) => (
        <div key={index} className="receipt" dangerouslySetInnerHTML={{ __html: html }} />
      ))}
    </div>
  )
}

export function ReceiptPreview({ receipts_html }: { receipts_html: string[] }) {
  if (receipts_html.length === 0) return null

  return (
    <Paper withBorder p="xl" radius="md" shadow="sm">
      <Stack gap="md">
        <Text fw={900} size="xs" c="dimmed" tt="uppercase" lts="1px">
          Aperçu des tickets
        </Text>
        {receipts_html.map((html, index) => (
          <Paper key={index} withBorder p={0} radius="sm" bg="white" maw={420}>
            <div className="receipt" dangerouslySetInnerHTML={{ __html: html }} />
          </Paper>
        ))}
      </Stack>
    </Paper>
  )
}
